// @generated by protoc-gen-es v1.6.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/chat/message_type.proto (package qliq_protobuf.chat, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum qliq_protobuf.chat.MessageType
 */
export enum MessageType {
  /**
   * Bot Messages
   *
   * @generated from enum value: TEXT = 0;
   */
  TEXT = 0,

  /**
   * @generated from enum value: EMBED = 1;
   */
  EMBED = 1,

  /**
   * @generated from enum value: QUICK_REPLY = 2;
   */
  QUICK_REPLY = 2,

  /**
   * @generated from enum value: QUICK_REPLY_CHOICE = 3;
   */
  QUICK_REPLY_CHOICE = 3,

  /**
   * @generated from enum value: CAROUSEL = 4;
   */
  CAROUSEL = 4,

  /**
   * @generated from enum value: QUICK_FORM = 5;
   */
  QUICK_FORM = 5,

  /**
   * @generated from enum value: FAQ = 6;
   */
  FAQ = 6,

  /**
   * @generated from enum value: AUDIO_VIDEO_TEST = 7;
   */
  AUDIO_VIDEO_TEST = 7,

  /**
   * @generated from enum value: IMAGE = 8;
   */
  IMAGE = 8,

  /**
   * @generated from enum value: VIDEO = 9;
   */
  VIDEO = 9,

  /**
   * @generated from enum value: ESCALATION = 10;
   */
  ESCALATION = 10,

  /**
   * @generated from enum value: SIGN_OFF = 11;
   */
  SIGN_OFF = 11,

  /**
   * @generated from enum value: DELAY = 12;
   */
  DELAY = 12,

  /**
   * Integration Messages
   *
   * @generated from enum value: API = 13;
   */
  API = 13,

  /**
   * @generated from enum value: EMR_SYNC = 14;
   */
  EMR_SYNC = 14,

  /**
   * @generated from enum value: PATIENT_MATCH = 15;
   */
  PATIENT_MATCH = 15,

  /**
   * @generated from enum value: PATIENT_VALIDATION = 16;
   */
  PATIENT_VALIDATION = 16,

  /**
   * @generated from enum value: DOCUSIGN = 17;
   */
  DOCUSIGN = 17,

  /**
   * @generated from enum value: SCHEDULER = 18;
   */
  SCHEDULER = 18,

  /**
   * @generated from enum value: QUINCY_PAY = 19;
   */
  QUINCY_PAY = 19,

  /**
   * Other Chat Messages
   *
   * @generated from enum value: NOTIFICATION = 20;
   */
  NOTIFICATION = 20,

  /**
   * @generated from enum value: BOT_NOTIFICATION = 21;
   */
  BOT_NOTIFICATION = 21,

  /**
   * @generated from enum value: ASSIGNEE_UPDATE_NOTIFICATION = 22;
   */
  ASSIGNEE_UPDATE_NOTIFICATION = 22,

  /**
   * @generated from enum value: BOT_ESCALATION = 23;
   */
  BOT_ESCALATION = 23,

  /**
   * @generated from enum value: WAITING_BOT_FINISHED = 24;
   */
  WAITING_BOT_FINISHED = 24,

  /**
   * @generated from enum value: KNOWN = 25;
   */
  KNOWN = 25,

  /**
   * @generated from enum value: ANONYMOUS = 26;
   */
  ANONYMOUS = 26,

  /**
   * @generated from enum value: WELCOME = 27;
   */
  WELCOME = 27,

  /**
   * @generated from enum value: TEASER = 28;
   */
  TEASER = 28,

  /**
   * @generated from enum value: COMPLIANCE = 29;
   */
  COMPLIANCE = 29,

  /**
   * @generated from enum value: START = 30;
   */
  START = 30,

  /**
   * @generated from enum value: TAC = 31;
   */
  TAC = 31,

  /**
   * @generated from enum value: ABOUT = 32;
   */
  ABOUT = 32,

  /**
   * @generated from enum value: NONQLIQ = 33;
   */
  NONQLIQ = 33,

  /**
   * @generated from enum value: VIDEO_CHAT_REQUEST = 34;
   */
  VIDEO_CHAT_REQUEST = 34,

  /**
   * @generated from enum value: VIDEO_CHAT_ACCEPT = 35;
   */
  VIDEO_CHAT_ACCEPT = 35,

  /**
   * @generated from enum value: VIDEO_CHAT_DECLINE = 36;
   */
  VIDEO_CHAT_DECLINE = 36,

  /**
   * @generated from enum value: VOICE = 37;
   */
  VOICE = 37,

  /**
   * @generated from enum value: STATUS_UPDATE_NOTIFICATION = 38;
   */
  STATUS_UPDATE_NOTIFICATION = 38,

  /**
   * @generated from enum value: UPDATE_UI = 39;
   */
  UPDATE_UI = 39,

  /**
   * @generated from enum value: VIDEO_CHAT_CANCEL = 40;
   */
  VIDEO_CHAT_CANCEL = 40,

  /**
   * @generated from enum value: TAC_ACCEPTED = 41;
   */
  TAC_ACCEPTED = 41,

  /**
   * @generated from enum value: TAC_DECLINED = 42;
   */
  TAC_DECLINED = 42,

  /**
   * @generated from enum value: TAC_PRESENTED = 43;
   */
  TAC_PRESENTED = 43,

  /**
   * @generated from enum value: QUICK_SIGN = 44;
   */
  QUICK_SIGN = 44,

  /**
   * @generated from enum value: PDF = 45;
   */
  PDF = 45,
}
// Retrieve enum metadata with: proto3.getEnumType(MessageType)
proto3.util.setEnumType(MessageType, "qliq_protobuf.chat.MessageType", [
  { no: 0, name: "TEXT" },
  { no: 1, name: "EMBED" },
  { no: 2, name: "QUICK_REPLY" },
  { no: 3, name: "QUICK_REPLY_CHOICE" },
  { no: 4, name: "CAROUSEL" },
  { no: 5, name: "QUICK_FORM" },
  { no: 6, name: "FAQ" },
  { no: 7, name: "AUDIO_VIDEO_TEST" },
  { no: 8, name: "IMAGE" },
  { no: 9, name: "VIDEO" },
  { no: 10, name: "ESCALATION" },
  { no: 11, name: "SIGN_OFF" },
  { no: 12, name: "DELAY" },
  { no: 13, name: "API" },
  { no: 14, name: "EMR_SYNC" },
  { no: 15, name: "PATIENT_MATCH" },
  { no: 16, name: "PATIENT_VALIDATION" },
  { no: 17, name: "DOCUSIGN" },
  { no: 18, name: "SCHEDULER" },
  { no: 19, name: "QUINCY_PAY" },
  { no: 20, name: "NOTIFICATION" },
  { no: 21, name: "BOT_NOTIFICATION" },
  { no: 22, name: "ASSIGNEE_UPDATE_NOTIFICATION" },
  { no: 23, name: "BOT_ESCALATION" },
  { no: 24, name: "WAITING_BOT_FINISHED" },
  { no: 25, name: "KNOWN" },
  { no: 26, name: "ANONYMOUS" },
  { no: 27, name: "WELCOME" },
  { no: 28, name: "TEASER" },
  { no: 29, name: "COMPLIANCE" },
  { no: 30, name: "START" },
  { no: 31, name: "TAC" },
  { no: 32, name: "ABOUT" },
  { no: 33, name: "NONQLIQ" },
  { no: 34, name: "VIDEO_CHAT_REQUEST" },
  { no: 35, name: "VIDEO_CHAT_ACCEPT" },
  { no: 36, name: "VIDEO_CHAT_DECLINE" },
  { no: 37, name: "VOICE" },
  { no: 38, name: "STATUS_UPDATE_NOTIFICATION" },
  { no: 39, name: "UPDATE_UI" },
  { no: 40, name: "VIDEO_CHAT_CANCEL" },
  { no: 41, name: "TAC_ACCEPTED" },
  { no: 42, name: "TAC_DECLINED" },
  { no: 43, name: "TAC_PRESENTED" },
  { no: 44, name: "QUICK_SIGN" },
  { no: 45, name: "PDF" },
]);

